<mat-card class="search-card">
  <mat-card-content>
    <mat-form-field appearance="fill" class="search-field">
      <mat-label>Kontakt suchen</mat-label>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        placeholder="Name oder E-Mail"
      />
    </mat-form-field>
    <mat-list *ngIf="filteredUsers.length > 0" class="result-list">
      <mat-list-item
        *ngFor="let user of filteredUsers"
        (click)="goToUserDetail(user.id!)"
      >
        {{ user.firstName }} {{ user.lastName }} – {{ user.mail }}
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>

<mat-card class="greeting-card">
  <mat-card-content>
    <h2>{{ greeting }} 👋</h2>
    <p>{{ currentDate }}</p>
    <p>Uhrzeit: {{ currentTime }}</p>
  </mat-card-content>
</mat-card>

<mat-card class="appointment-card">
  <mat-card-title>Nächste Termine</mat-card-title>
  <mat-card-content>
    <table *ngIf="usersWithAppointments.length > 0" class="appointment-table">
  <thead>
    <tr>
      <th>Datum & Uhrzeit</th>
      <th>Name</th>
      <th>Notiz</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of usersWithAppointments" (click)="goToUserDetail(user.id!)" class="clickable">
      <td>{{ user.date | date: "dd.MM.yyyy, HH:mm" }} Uhr</td>
      <td>{{ user.firstName }} {{ user.lastName }}</td>
      <td>{{ user.notice }}</td>
    </tr>
  </tbody>
</table>
<p *ngIf="usersWithAppointments.length === 0">Keine Termine vorhanden.</p>

  </mat-card-content>
</mat-card>

<mat-card class="count-card">
  <mat-card-content>
    <h3>Gesamtanzahl Kontakte</h3>
    <p>{{ totalUsers }}</p>
  </mat-card-content>
</mat-card>
